module.exports = __webpack_public_path__ + "static/media/ARLTUG-half.f1f34647.png";